import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { CloseDialog, OpenDialog, SendBookClubHistory } from './bookclub-links.actions';
import { BookclubLinksState } from './bookclub-links.state';
import { ExperienceLink, ExperienceModel } from 'src/app/models/experience-link';
import { Record } from 'src/app/models/record';

@Injectable({
  providedIn: 'root'
})
export class BookclubLinksDialogFacade {
  private readonly store = inject(Store);

  @Select(BookclubLinksState.open) open$!: Observable<boolean>;
  @Select(BookclubLinksState.title) title$!: Observable<string>;
  @Select(BookclubLinksState.links) links$!: Observable<ExperienceModel[]>;
  @Select(BookclubLinksState.resourceId) resourceId$!: Observable<string>;

  openDialog(record: Record, links: ExperienceLink[], resourceId?: string) {
    this.store.dispatch(new OpenDialog(record, links, resourceId));
  }

  closeDialog() {
    this.store.dispatch(new CloseDialog());
  }

  sendBookClubHistory(recordId: string, link: ExperienceLink, dontShow: boolean) {
    return this.store.dispatch(new SendBookClubHistory(recordId, link, dontShow));
  }
}
